import { useState } from "react"
import { Checkbox, FormControl, FormControlLabel, FormHelperText, MenuItem } from "@mui/material"
import { useAppLocalization } from "../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { ConfirmModal } from "../dialogs/ConfirmModal"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((_theme) => ({
    helperText: {
        marginLeft: 0,
        marginRight: 0,
    }
}))

type Props = Readonly<{
    subscriptionName: string
    customerName: string
    open: boolean
    onClose: () => void
    onCancelSubscription: (ignoreTerms: boolean) => void
}>

export const CancelSubscriptionConfirmDialog = (props: Props) => {
    const { subscriptionName, customerName, open, onClose, onCancelSubscription } = props
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const [ignoreTerms, setIgnoreTerms] = useState(false)

    return (
        <ConfirmModal
            title={l10n.getString("cancel-subscription-modal-title")}
            message={
                <LocalizedStrict
                    id="cancel-subscription-modal-message"
                    vars={{
                        subscriptionName,
                        customerName,
                    }}
                >
                    <span>{`Are you sure you want to cancel ${subscriptionName} for ${customerName}?`}</span>
                </LocalizedStrict>
            }
            buttonLabelSubmit={l10n.getString("cancel-subscription-modal-button-delete")}
            open={open}
            onClose={onClose}
            handleClick={() => onCancelSubscription(ignoreTerms)}
        >
            <FormControl>
                <LocalizedStrict id="cancel-subscription-modal-label-ignore-terms" attrs={{ label: true }}>
                    <FormControlLabel
                        label="Effective immediately"
                        control={
                            <Checkbox
                                checked={ignoreTerms}
                                onChange={(_event, checked)  => setIgnoreTerms(checked)}
                            />
                        }
                    />
                </LocalizedStrict>
                <LocalizedStrict id="cancel-subscription-modal-helper-text-ignore-terms">
                    <FormHelperText className={classes.helperText}>This will ignore the subscription terms.</FormHelperText>
                </LocalizedStrict>
            </FormControl>
        </ConfirmModal>
    )
}
